import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { createCheckoutSession } from "../services";

export const useCheckout = () => {
  const [error, setErrors] = useState();
  const { pathname } = useLocation();

  const performCheckout = useCallback(
    (eventUuid: string, productUuid: string) => {
      createCheckoutSession(eventUuid, productUuid, pathname).then((data) => {
        if (data.checkoutUrl) window.location.href = data.checkoutUrl;
        if (data.errors) setErrors(data.errors);
      });
    },
    [pathname]
  );

  return { performCheckout, error };
};
